<div class="mib-app-frame">
  <div class="box mib-app-top-bar">
    <div class="box"><a  routerLink="/"><img class="abb-logo" src="resources/abb_logo.png"></a></div>
    <div class="box title-logo"><a  routerLink="/">Motion Installed Base</a></div>
    <div class="box spacer"></div>
    <div class="box user-menu">
      <button *ngIf="email" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Tools menu">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <a mat-menu-item color="primary" routerLink="/search">
          <mat-icon>search</mat-icon>
          Search
        </a>
        <a mat-menu-item color="primary" routerLink="/product-tree/1831">
          <mat-icon>search</mat-icon>
          Product tree
        </a>
        <mat-divider></mat-divider>
        <a mat-menu-item color="primary" routerLink="/create-asset">
          <mat-icon>add</mat-icon>
          Create asset
        </a>
         <a mat-menu-item color="primary" routerLink="/import-assets">
            <mat-icon>upload_file</mat-icon>
            Import assets
          </a>
         <a mat-menu-item color="primary" routerLink="/import-registrations">
            <mat-icon>upload_file</mat-icon>
           Import registrations
         </a>
          <a mat-menu-item color="primary" routerLink="/import-spare-parts">
            <mat-icon>upload_file</mat-icon>
            Import spare parts
          </a>
    
        <mat-divider></mat-divider>
        <a mat-menu-item color="primary" (click)="logout()">
          <mat-icon>logout</mat-icon>
          Logout
        </a>
      </mat-menu>
    </div>
  </div>
  <div class="box mip-app-switcher">
    <div class="box switcher-element">Home</div>
    <div class="box switcher-element active">Assets</div>
    <div class="box switcher-element">Service Reports</div>
    <div class="box switcher-element">Services</div>
  </div>


 <div class="box mib-app-main" role="main">



      <router-outlet></router-outlet>

  </div>
  
</div> 
